module.exports = __webpack_public_path__ + "fonts/Inter-300-cyrillic37.de93fdc.woff2";